import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { ArrowForwardIos } from "@mui/icons-material";

export default memo(({ data, isConnectable }) => {
  return (
    <div
      style={{
        backgroundColor: "#FFF8E1",
        padding: "8px",
        borderRadius: "8px",
        width: 180,
        border: "1px solid #FFC107",
        color: "#232323",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#FFC107",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px"
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          fontWeight: "bold",
          marginBottom: 5,
          color: "#232323",
          fontSize: "16px"
        }}
      >
        📩 Template
      </div>

      <div
        style={{
          fontSize: "12px",
          marginBottom: 10,
          color: "#232323",
          wordBreak: "break-word"
        }}
      >
        {data.templateName || "Sem template"}
      </div>

      {(data.buttons || []).map((btn, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: 8,
            position: "relative"
          }}
        >
          <div
            style={{
              fontSize: "10px",
              color: "#232323",
              marginRight: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "120px"
            }}
          >
            {btn.text}
          </div>

          <Handle
            type="source"
            position="right"
            id={"btn_" + (btn.key || index)}
            style={{
              top: "50%",
              transform: "translateY(-50%)",
              background: "#FFC107",
              width: "18px",
              height: "18px",
              right: "-11px"
            }}
            isConnectable={isConnectable}
          >
            <ArrowForwardIos
              sx={{
                color: "#fff",
                width: "10px",
                height: "10px",
                marginLeft: "2px",
                pointerEvents: "none"
              }}
            />
          </Handle>
        </div>
      ))}
    </div>
  );
});